import AppContext from 'App/AppContext';
import { IPProgressBar } from 'baseComponents';
import { useContext } from 'react';

//
// The thin progress bar over the top edge of the content area while appContext.showContentLoader() is on.
// Positioned over the content, so it never moves the scene below it.
//
const ContentLoader = () => {
  const appContext = useContext(AppContext);

  if (!appContext.isContentLoading) {
    return null;
  }

  return (
    <div style={{ position: 'relative', height: 0 }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 10 }}>
        <IPProgressBar thickness="medium" />
      </div>
    </div>
  );
};

export default ContentLoader;
